import { ipsos, supuesto } from ".";

// Lámina 60 (penetración/tipo/frecuencia/gasto/dónde compra, base 400/261), lámina 61
// (marcas, base 261), lámina 62 (factores/importancia, base 261).
const P_USA = "¿Utiliza productos de cuidado o belleza personal regularmente?";
const P_TIPO = "¿Qué tipo de productos de cuidado o belleza personal compra con mayor frecuencia?";
const P_FRECUENCIA = "¿Con qué frecuencia compra estos productos?";
const P_GASTO = "¿Cuánto gasta en promedio al mes en productos de cuidado o belleza personal?";
const P_DONDE = "¿Dónde suele comprar estos productos?";
const P_MARCA_ESPONTANEA = "¿Qué marcas de cuidado o belleza personal prefiere? (espontánea)";
const P_MARCA_GUIADA = "Y de estas marcas, ¿cuáles prefiere? (guiada)";
const P_FACTORES = "¿Qué factores prioriza al comprar estos productos?";
const P_IMPORTANCIA = "¿Qué tan importante es para usted el cuidado y la belleza personal?";

// NOTA DE DATOS (heredada): los rótulos "Tiendas por departamento", "Tiendas especializadas"
// y "Plataformas online" (en dondeCompra) fueron definidos por Ignacio — venían truncados en
// la fuente del estudio. El resto de los valores es IPSOS textual. En marcas se usa la grafía
// real corregida (no la del estudio) + el holding propietario (holding no se muestra en la UI,
// queda en la data para eventual agrupación futura).
export const IPSOS_BELLEZA = {
  penetracion: {
    usa: ipsos(0.659, { lamina: 60, pregunta: P_USA, base: 400 }),
    noUsa: ipsos(0.341, { lamina: 60, pregunta: P_USA, base: 400 }),
  },

  tipoProducto: {
    facial: { pct: ipsos(0.795, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Facial" },
    perfumes: { pct: ipsos(0.592, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Perfumes" },
    higiene: { pct: ipsos(0.538, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Higiene" },
    capilar: { pct: ipsos(0.521, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Capilar" },
    corporal: { pct: ipsos(0.466, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Corporal" },
    maquillaje: { pct: ipsos(0.325, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Maquillaje" },
    manicura: { pct: ipsos(0.169, { lamina: 60, pregunta: P_TIPO, base: 261 }), label: "Manicura" },
  },

  // factor = tickets/mes por persona (supuesto comercial derivado de la frecuencia Ipsos)
  frecuencia: [
    {
      pct: ipsos(0.141, { lamina: 60, pregunta: P_FRECUENCIA, base: 261 }),
      label: "Semanal",
      factor: supuesto(4, { nota: "tickets/mes" }),
    },
    {
      pct: ipsos(0.694, { lamina: 60, pregunta: P_FRECUENCIA, base: 261 }),
      label: "Mensual",
      factor: supuesto(1, { nota: "tickets/mes" }),
    },
    {
      pct: ipsos(0.145, { lamina: 60, pregunta: P_FRECUENCIA, base: 261 }),
      label: "Cada 2 a 3 meses",
      factor: supuesto(0.4, { nota: "tickets/mes" }),
    },
    {
      pct: ipsos(0.02, { lamina: 60, pregunta: P_FRECUENCIA, base: 261 }),
      label: "Cada 6 meses o más",
      factor: supuesto(0.17, { nota: "tickets/mes" }),
    },
  ],

  // midpoint = punto medio del tramo (supuesto comercial: interpolación del tramo abierto Ipsos)
  gastoMensual: [
    {
      pct: ipsos(0.043, { lamina: 60, pregunta: P_GASTO, base: 261 }),
      label: "<$10.000",
      midpoint: supuesto(5000, { nota: "punto medio del tramo" }),
    },
    {
      pct: ipsos(0.335, { lamina: 60, pregunta: P_GASTO, base: 261 }),
      label: "$10.000-$30.000",
      midpoint: supuesto(20000, { nota: "punto medio del tramo" }),
    },
    {
      pct: ipsos(0.393, { lamina: 60, pregunta: P_GASTO, base: 261 }),
      label: "$30.001-$50.000",
      midpoint: supuesto(40000, { nota: "punto medio del tramo" }),
    },
    {
      pct: ipsos(0.229, { lamina: 60, pregunta: P_GASTO, base: 261 }),
      label: ">$50.000",
      midpoint: supuesto(75000, { nota: "punto medio del tramo abierto" }),
    },
  ],

  dondeCompra: [
    { pct: ipsos(0.618, { lamina: 60, pregunta: P_DONDE, base: 261 }), label: "Farmacias" },
    {
      pct: ipsos(0.3, {
        lamina: 60,
        pregunta: P_DONDE,
        base: 261,
        nota: "rótulo truncado en la fuente, definido por Ignacio",
      }),
      label: "Tiendas por departamento",
    },
    {
      pct: ipsos(0.227, {
        lamina: 60,
        pregunta: P_DONDE,
        base: 261,
        nota: "rótulo truncado en la fuente, definido por Ignacio",
      }),
      label: "Tiendas especializadas",
    },
    { pct: ipsos(0.205, { lamina: 60, pregunta: P_DONDE, base: 261 }), label: "Supermercados" },
    {
      pct: ipsos(0.114, {
        lamina: 60,
        pregunta: P_DONDE,
        base: 261,
        nota: "rótulo truncado en la fuente, definido por Ignacio",
      }),
      label: "Plataformas online",
    },
    { pct: ipsos(0.05, { lamina: 60, pregunta: P_DONDE, base: 261 }), label: "Redes sociales" },
    { pct: ipsos(0.043, { lamina: 60, pregunta: P_DONDE, base: 261 }), label: "Mercado Pago" },
  ],

  factores: [
    { pct: ipsos(0.902, { lamina: 62, pregunta: P_FACTORES, base: 261 }), label: "Calidad" },
    { pct: ipsos(0.462, { lamina: 62, pregunta: P_FACTORES, base: 261 }), label: "Precio" },
    { pct: ipsos(0.152, { lamina: 62, pregunta: P_FACTORES, base: 261 }), label: "Ingredientes naturales o veganos" },
    { pct: ipsos(0.098, { lamina: 62, pregunta: P_FACTORES, base: 261 }), label: "Marca reconocida" },
    {
      pct: ipsos(0.036, { lamina: 62, pregunta: P_FACTORES, base: 261 }),
      label: "Recomendaciones (amigos, influencers, etc.)",
    },
    { pct: ipsos(0.032, { lamina: 62, pregunta: P_FACTORES, base: 261 }), label: "Cruelty-free" },
    {
      pct: ipsos(0.014, { lamina: 62, pregunta: P_FACTORES, base: 261 }),
      label: "Sostenibilidad (envases reciclables, eco-friendly)",
    },
  ],

  importancia: [
    { pct: ipsos(0.771, { lamina: 62, pregunta: P_IMPORTANCIA, base: 261 }), label: "Muy importante" },
    { pct: ipsos(0.143, { lamina: 62, pregunta: P_IMPORTANCIA, base: 261 }), label: "Bastante importante" },
    { pct: ipsos(0.087, { lamina: 62, pregunta: P_IMPORTANCIA, base: 261 }), label: "Algo importante" },
  ],

  marcasEspontanea: [
    {
      nombre: "Nivea",
      pct: ipsos(0.344, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "Beiersdorf",
    },
    {
      nombre: "Maybelline",
      pct: ipsos(0.287, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "L'Oréal",
    },
    { nombre: "Dove", pct: ipsos(0.203, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }), holding: "Unilever" },
    {
      nombre: "Garnier",
      pct: ipsos(0.12, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "L'Oréal",
    },
    {
      nombre: "Rexona",
      pct: ipsos(0.099, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "Unilever",
    },
    {
      nombre: "Clinique",
      pct: ipsos(0.087, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "Estée Lauder",
    },
    { nombre: "Gillette", pct: ipsos(0.077, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }), holding: "P&G" },
    {
      nombre: "La Roche-Posay",
      pct: ipsos(0.073, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "L'Oréal",
    },
    {
      nombre: "Neutrogena",
      pct: ipsos(0.043, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "Kenvue",
    },
    {
      nombre: "L'Oréal",
      pct: ipsos(0.03, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "L'Oréal",
    },
    {
      nombre: "Eucerin",
      pct: ipsos(0.03, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "Beiersdorf",
    },
    { nombre: "Isdin", pct: ipsos(0.023, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }), holding: "Isdin" },
    {
      nombre: "Mennen",
      pct: ipsos(0.019, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "Colgate-Palmolive",
    },
    {
      nombre: "Elvive",
      pct: ipsos(0.018, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "L'Oréal",
    },
    { nombre: "Vichy", pct: ipsos(0.017, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }), holding: "L'Oréal" },
    {
      nombre: "Lancôme",
      pct: ipsos(0.016, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "L'Oréal",
    },
    { nombre: "Pantene", pct: ipsos(0.008, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }), holding: "P&G" },
    {
      nombre: "Marca coreana",
      pct: ipsos(0.006, { lamina: 61, pregunta: P_MARCA_ESPONTANEA, base: 261 }),
      holding: "—",
    },
  ],

  marcasGuiada: [
    {
      nombre: "Maybelline",
      pct: ipsos(0.206, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }),
      holding: "L'Oréal",
    },
    { nombre: "Dove", pct: ipsos(0.197, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "Unilever" },
    { nombre: "Nivea", pct: ipsos(0.195, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "Beiersdorf" },
    { nombre: "Gillette", pct: ipsos(0.153, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "P&G" },
    {
      nombre: "Clinique",
      pct: ipsos(0.126, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }),
      holding: "Estée Lauder",
    },
    { nombre: "L'Oréal", pct: ipsos(0.105, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "L'Oréal" },
    { nombre: "Elvive", pct: ipsos(0.091, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "L'Oréal" },
    { nombre: "Garnier", pct: ipsos(0.078, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "L'Oréal" },
    { nombre: "Rexona", pct: ipsos(0.071, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "Unilever" },
    { nombre: "Otra", pct: ipsos(0.079, { lamina: 61, pregunta: P_MARCA_GUIADA, base: 261 }), holding: "—" },
  ],
};

// Checkpoints de monto (gasto mensual por persona) — supuesto comercial, valores fijos del
// selector (el "promedio" se calcula en el componente a partir de gastoMensual)
export const MONTOS_FIJOS = [
  supuesto(10000, { nota: "gasto mensual por persona" }),
  supuesto(20000, { nota: "gasto mensual por persona" }),
  supuesto(40000, { nota: "gasto mensual por persona" }),
  supuesto(75000, { nota: "gasto mensual por persona" }),
];
